import HttpClient from "libs/utils/HttpClient";

class NotificationService {
  async getNotifications() {
    try {
      const response = await HttpClient.get(`/api/notification/list`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async readNotifications(body) {
    try {
      const response = await HttpClient.post(`/api/notification/read`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async trashNotifications(body) {
    try {
      const response = await HttpClient.post(`/api/notification/trash`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new NotificationService();



